import { render, staticRenderFns } from "./NSIPage.vue?vue&type=template&id=0c27fd30&"
import script from "./NSIPage.vue?vue&type=script&lang=js&"
export * from "./NSIPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports